import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalBasePagamentoComponent } from '../../../common/modal-base-pagamento/modal-base-pagamento.component';

@Component({
  selector: 'app-modal-pagamento',
  templateUrl: './modal-pagamento.component.html',
  styleUrls: ['./modal-pagamento.component.scss']
})
export class ModalPagamentoComponent implements OnInit {
  @Input() idOrdine: number;
  @Output() onSubmitEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output() onCancelEmitter: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(ModalBasePagamentoComponent, {static : true}) child:ModalBasePagamentoComponent;

  constructor() { }

  ngOnInit(): void {
  }

  onCancel() {
    this.onCancelEmitter.emit(null);
  }

  onSubmit() {
    this.onSubmitEmitter.emit(null);
  }

  annullaPagamento(idOrdine) {
    this.child.annullaPagamento(idOrdine);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('idOrdine' in changes) {
      this.child.openModal(this.idOrdine);
    }
  }

}
